const CONSENT = {
    CONTACT: 'contact',
    SHARE: 'share',
    PARTICIPATE: 'participate',
};

export default CONSENT;
